
// Libraries
var React = require('react');
var sneakpeek = require('sneakpeek');

var HashChange = require('../../HashChange/HashChangeModule');

// Styles
require('./SubNavigationBar.scss');

// Assets
var chevronSvg = require('images/chevron.svg');
var chevronSvgYellow = require('images/chevron_yellow.svg');
var logoImg = require('images/logo-new.svg');
var poppyLogo = require('images/poppy.png');

class SubNavigationBar extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			...this.props,
			moreLinks: null,
			isDropdownOpen: false
		};
	}

	componentWillMount() {

		let mobileLinks = this.state.links;

		// This will allow the BE to send either null
		// or an empty array to disable the dropdown.
		if (mobileLinks === null) mobileLinks = [];

		if (mobileLinks.length > 5) {
			let moreLinks = this.state.links.slice(4, this.state.links.length);
			let links = this.state.links.slice(0, 4);

			this.setState({
				links: links,
				moreLinks: moreLinks,
				mobileLinks: mobileLinks
			});
		} else {
			this.setState({
				links: mobileLinks,
				mobileLinks: mobileLinks
			});
		}
	}

	componentDidMount() {
		sneakpeek(this.subNav);

		let emitter = require('sneakpeek').emitter;

		// Closes the menu on scroll down.
		emitter.on('hide', () => {
			this.setState({
				isDropdownOpen: false
			});
		});

		if (typeof window === "undefined") return;

		if (window.location.hash) {

			this.subNav.classList.add('sneakpeek--hidden');

			this.setState({
				isDropdownOpen: false
			});

		}
		
	}

	handleEscClose = (event) => {
		if (event.key === 'Escape') {
			this.toggleMenu();
		}
	}

	toggleMenu = () => {
		this.setState({
			isDropdownOpen: !this.state.isDropdownOpen
		}, () => {
			if(this.moreButton) this.moreButton.focus();
		});
	};

	render() {

		let areThereAnyLinks = () => {
			return this.state.links.length === 0 ? " no-links" : "";
		};

		let poppy;

		if (this.props.showLogoPoppy) {
			poppy = <img src={poppyLogo} className={"SubNavigationBar__crest__holiday"} alt="" />;
		}

		return (
			<div id="sub-nav" className={"SubNavigationBar" + areThereAnyLinks()} ref={(subNav) => { this.subNav = subNav; }} role="menubar">
				<a className="SubNavigationBar__crest" href="/" role="menuitem">
					<img src={logoImg} alt="Navigate to home" />
					{poppy}
				</a>

				{/* Mobile Nav with dropdown */}
				<div className={"SubNavigationBar--mobile"}>

					{/* Dropdown handler and current page */}
					<div aria-hidden className={"SubNavigationBar__header"} onClick={this.toggleMenu} role="menuitem">
						<div className={this.state.mobileLinks.some((item) => item.isSelected === true) ? "SubNavigationBar__item in-sub-selected" : "SubNavigationBar__item"} onClick={this.toggleMenu}>
							{this.state.parentLink.caption !== '' &&
									<span className={"SubNavigationBar__item__main"}>{this.state.parentLink.caption} {this.state.mobileLinks.length > 0 && <img src={chevronSvg} alt="" aria-hidden/>}</span>
							}
							{this.state.mobileLinks.length > 0 && this.state.mobileLinks.find(x => x.isSelected) &&
									<span className={"SubNavigationBar__item__sub"}>{this.state.mobileLinks.find(x => x.isSelected).caption} <img src={chevronSvgYellow} alt="" aria-hidden/></span>
							}
						</div>
					</div>

					{/* Dropdown with sub pages and highlighting current page */}
					<div aria-hidden className={"SubNavigationBar__dropdown" + (this.state.isDropdownOpen ? " is-open" : "")} role="menuitem">
						{this.state.mobileLinks.length > 0 && this.state.parentLink.url &&
							<div className={this.state.parentLink.isSelected ? "SubNavigationBar__item is-parent in-sub-selected" : "SubNavigationBar__item is-parent"}>
								<a href={this.state.parentLink.url} className={"SubNavigationBar__item__sub"}>{this.state.parentLink.caption}</a>
							</div>
						}
						{this.state.mobileLinks.length > 0 && this.state.mobileLinks.map((item, index) => {
							return(
								<div className={item.isSelected ? "SubNavigationBar__item in-sub-selected" : "SubNavigationBar__item"} key={index}>
									<a href={item.url} target={item.newWindow ? "_blank" : "_self"} rel={item.newWindow ? "noreferrer noopener" : undefined} className={"SubNavigationBar__item__sub"}>{item.caption}</a>
								</div>
							)
						})}
					</div>
				</div>

				{/* Desktop Nav with horizontal items */}
				{ this.state.links.length > 0 &&
						<div className="SubNavigationBar--desktop" role="list">
							{this.state.parentLink.caption !== '' &&
								<div className={this.state.parentLink.isSelected ? "SubNavigationBar__item is-parent in-sub-selected" : "SubNavigationBar__item is-parent" } role="listitem">
									{this.state.parentLink.url
										? (<a href={this.state.parentLink.url} className={"SubNavigationBar__item__sub"}>{this.state.parentLink.caption}</a>)
										: (<span className={"SubNavigationBar__item__sub"}>{this.state.parentLink.caption}</span>)
									}
								</div>
							}

							{this.state.links.length > 0 && this.state.links.map((item, index) => {
								return(
									<div className={item.isSelected ? "SubNavigationBar__item in-sub-selected" : "SubNavigationBar__item"} key={index} role="listitem">
										<a href={item.url} target={item.newWindow ? "_blank" : "_self"} rel={item.newWindow ? "noreferrer noopener" : undefined} className={"SubNavigationBar__item__sub"}>{item.caption}</a>
									</div>
								)
							})}

							{this.state.moreLinks &&
									<div onClick={this.toggleMenu} className={"SubNavigationBar__item SubNavigationBar__handle" + (this.state.isDropdownOpen ? " is-open" : "")} key="DesktopHandle" role="listitem" aria-haspopup="true" onKeyDown={this.handleEscClose}>


										<button href="#" className={"SubNavigationBar__item__sub" + (this.state.moreLinks.find(x => x.isSelected) ? " in-sub-selected" : "")} aria-expanded={this.state.isDropdownOpen} ref={(button) => this.moreButton = button}>More</button>

										<div className={"SubNavigationBar__dropdown" + (this.state.isDropdownOpen ? " is-open" : "")} role="list">
											{this.state.moreLinks.map((item, index) => {
														return(
															<div className={item.isSelected ? "SubNavigationBar__item in-sub-selected" : "SubNavigationBar__item"} key={index} role="listitem">
																<a href={item.url} target={item.newWindow ? "_blank" : "_self"} rel={item.newWindow ? "noreferrer noopener" : undefined} className={"SubNavigationBar__item__sub"}>{item.caption}</a>
															</div>
														)
													})
											}
										</div>
									</div>
							}
						</div>
				}
				<HashChange />
			</div>
		)
	}
}

module.exports = SubNavigationBar;



// WEBPACK FOOTER //
// ./src/components/Navigation/SubNavigation/SubNavigationBar.js